module.exports = __webpack_public_path__ + "img/logo_fastalways_transparente.9dcd340d.png";